import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";

export default function HomeBanner3(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					padding: "0",
					backgroundImage: `url(${banner5})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				
				<div className="container">
					<div className="row" >

						<div className="col-md-12">
							
							<div
								style={{
									padding: "20px",
									marginTop: "30px",
									marginBottom: "30px",
									background: "rgba(255, 255, 255, 0.7)",
									borderRadius: "10px"
								}}

								className=""
							>
								<h6
									className="main-section-title"
								>
									Expertise
									<br />
									<span 
										style={{
											fontSize:"24px"
										}}
										className="text-dim font-light"
									>
										We specialize in delivering reliable and innovative ICT solutions tailored to your business needs.
									</span>
								</h6>

								<div className="row d-flex justify-content-center">
									<div className="col-md-6 mt-2 rounded bg-primary p-3">
										<div>
											<h5 className="text-light font-bold mt-1">
												Main Strength of BOSTON lies in the blend of professionals, specialized and highly focused operation.
											</h5>
										</div>
										<div>
											<h6 className="text-light font-light mt-3 lh-lg">
												Our strength lies in our ability to blend current management practice and IT expertise into cost effective Computer Aided Management Solutions, Products and Services.
												<br />
												<br/>
												Increasing customer’s awareness is the strength where it excels over its competitors. 
												<br/><br />
												BOSTON understands the need for skill transfer to client personnel. 
											</h6>
										</div>
									</div>
									<div className="col-md-6 mt-2 rounded bg-secondary d-flex flex-column justify-content-evenly p-3 text-center">
										<div>
											<div className="font-bold mb-3">
												<h1>15+</h1>
											</div>
											<h6>
												Years Of Experience
											</h6>
										</div>
										
										<hr />
										<h6 class="fw-bold mb-3 text-center">Our Offers Cover the Following Major Areas:</h6>
										<div class="row">
											<div class="col-md-6">
											<ul class="list-unstyled mb-0 text-start">
												<li>• System Analysis & Business Process Reengineering</li>
												<li>• Customized Software & Application Development</li>
												<li>• Network Design, Monitoring & Security Management</li>
												<li>• Hardware Supply, Installation & Maintenance</li>
												<li>• Data Centre, Infrastructure & Power Solutions</li>
											</ul>
											</div>
											<div class="col-md-6">
											<ul class="list-unstyled mb-0 text-start">
												<li>• Automation & Integration for Enterprises</li>
												<li>• Project Management & Technical Support</li>
												<li>• Web, E-Business & Cloud-Based Solutions</li>
												<li>• Data Conversion, Recovery & Storage Management</li>
												<li>• Multimedia & Video Editing Solutions</li>
											</ul>
											</div>
										</div>

										
									</div>
								</div>
								
							</div>

						</div>

						
					</div>

				
				</div>
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
